import { combineReducers } from 'redux';
import theme from './slices/themeSlice';
import alexa from './slices/alexaSlice';
import onePage from './slices/onePageSlice';
import products from './slices/productSlice';
import mobileApps from './slices/mobileAppSlice';


import auth from './slices/authSlice';

const rootReducer = (asyncReducers) => (state, action) => {
  if (action.type === 'auth/signOut/fulfilled') {
    state = undefined;
  }

  const combinedReducer = combineReducers({
    theme,
    auth,
    alexa,
    onePage,
    products,
    mobileApps,
    ...asyncReducers,
  });

  return combinedReducer(state, action);
};

export default rootReducer;